import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../../utils/baseQuery";
import { components } from "../../types/api";

type BackfillResponse = components["schemas"]["ApiResponse_BackfillResponse_"];
type BackfillBriefingCategoryResponse =
  components["schemas"]["ApiResponse_BackfillBriefingCategoryResponse_"];

export const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    backfillSelectedIos: builder.mutation<
      BackfillResponse,
      { dryRun?: boolean }
    >({
      query: (body) => ({
        url: "/admin/tools/backfill-selected-ios",
        method: "POST",
        body,
      }),
    }),
    backfillBriefingCategory: builder.mutation<
      BackfillBriefingCategoryResponse,
      { dryRun?: boolean }
    >({
      query: (body) => ({
        url: "/admin/tools/backfill-briefing-category",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useBackfillSelectedIosMutation,
  useBackfillBriefingCategoryMutation,
} = adminApi;
